{
  "campuses": "Campuses",
  "deleteCampus": "Delete Campus",
  "campusNumber": "Campus Number",
  "campusAddress": "Campus Address",
  "viewCampusTabs": "view campus",
  "addCampus": "Add Campus",
  "campusNotDeleted": "Campus Not Deleted",
  "campusActiveIncidentPleaseResolve": "This campus has an active incident. Please resolve it before deleting.",
  "editCampus": "Edit Campus",
  "campusUpdated": "Campus updated",
  "campusCreated": "Campus created",
  "viewCampusTitle": "View Campus",
  "campusDeleteWarning": "Once {{name}} campus is deleted, we will no longer be able to protect it or provide emergency response services for this site.",
  "campusDetails": "Campus Details",
  "campusLevelMin": "Campus Level cannot be less than 1.",
  "createFirstCampus": "Create First Campus",
  "nextCreateACampusWithin": "Next, create a campus within your district",
  "createCampus": "Create Campus"
}
